export const cookieStrings = {
    title: "Cookie - Manage consent",
    description: "We respect your privacy. This website uses cookies and similar technologies to optimize the online experience, analyze user behavior and provide personalized advertising. You can adjust your consent at any time. However, without consent, some functions of the website may be restricted.",
    accept_all: "Accept all",
    deny_all: "Discard",
    manage: "Settings",
    save_settings: "Save Settings",
    necessary_title: "Necessary",
    necessary_description: "The storage of technical data or access to it is strictly necessary to enable the service you have requested or to reliably carry out message transmissions on electronic communications networks.",
}